import React, { useState, useEffect, useRef } from 'react'
import { useParams, Redirect } from "react-router-dom";

import "@fancyapps/ui/dist/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox.css";

import NormalContent from './Normal';
import CardContent from './Card';
import NewsCardsContent from './NewsCards';
import PressCardsContent from './PressCards';
import AccordionContent from './Accordion';
import TabContent from './Tabs';
import NewsContent from './News';
import ContactContent from './ContactForm';
//import ContactContent from '../Forms/ContactForm';
import ListContent from './List';
import ListAltContent from './ListAlt';
import NotFound from './NotFound';
//import MapaPistas from '../MapaPistas/mapaPistas';

import GalleryCardsContent from './GalleryCards';
import GalleryContent from './Gallery';

import AccommodationCardsContent from './AccommodationCards';
import AccommodationContent from './Accommodation';
import RestaurantCardsContent from './RestaurantCards';
import RestaurantContent from './Restaurant';
import TouristicOfferCardsContent from './TouristicOfferCards';
import TouristicOfferContent from './TouristicOffer';

import EventsCardsContent from './EventsCards';
import EventsContent from './Events';

import AnimationCardsContent from './AnimationCards';
import AnimationContent from './Animation';

// import RoutesCardsContent from './RoutesCards';
// import RoutesContent from './Routes';
import RoutesCardsContent from '../Estrela/RoutesCards';
import RoutesContent from '../Estrela/Routes';
import RoutesContentAlt from '../Estrela/Routes_alt';

//import Livecam from '../Navbar_Extra/Livecam';
//import Accesses from '../Navbar_Extra/Accesses';
import Loader from '../../../loader';

import * as Hosts from '../../../Hosts';
import { reqGET } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';

import './Content.css';

export default function Content() {

    const { pag_id, slug, article_id, gallery_id, press_id, routes_id, routesalt_id, accommodation_id, restaurant_id, event_id, animation_id, touristic_id, preview_id } = useParams();
    const [isloading, setLoading] = useState(true);


    console.log('animation_id', animation_id)


    /*
    const data_interface = {
        id: '',
        info: {
            type: 'news',
            layout: 'all'
        },
        content: {}
    }
    */
    // const [content, set_content] = useState(data_interface);

    const [, set_content] = useState(null);
	const content = useRef(null);

    useEffect(() => {


        let getPreviewInfoId = async (id) => {
            await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${id}`)
                .then(res => { 
                    if(res.data.length > 0) {

                        if(getTokenInfo()['profile'] !== '') {
                            res.data[0].info['preview'] = true
                            set_content(content.current = res.data[0])
                            setLoading(false)
                        }
                        else {
                        }
                    }
                })
                .catch(erro => console.log('ERROR', erro))
        }

        let getInfoId = async (id) => {
            await reqGET(`${Hosts.SIMCore_API}/web/content/${Hosts.companycode}/${id}`)
                .then(res => { 
                    if(res.data.length > 0) {

                        var hoje = new Date();
                        let status = 0
                        if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                            var date_p = new Date(res.data[0].info.date.published);

                            status = 1
                            if(hoje >= date_p) 
                                status = 2
                        }

                        if(status !== 2) {
                            //res.data[0].content[0] = {text: 'rascunho ou agendado'}
                            res.data[0].info.layout = '404'
                        }

                        set_content(content.current = res.data[0])
                        setLoading(false)
                    }
                    else {
                        if(article_id !== undefined && article_id !== 'undefined' && article_id !== '')
                            set_content(content.current = {id: id, info: {type: 'news', layout: '404'}, content: []})
                        else
                            set_content(content.current = {id: id, info: {type: 'content', layout: '404'}, content: []})

                        setLoading(false)
                    }
                })
                .catch(erro => console.log('ERROR', erro))
        }

        let getInfoRoutesId = async (id) => {
            await reqGET(`${Hosts.SIMCore_API}/platform/routes/${id}`)
                .then(res => { 
                    if(res.data.length > 0) {

                        //let status = 0
                        if(res.data[0].activo && res.data[0].visible !== '') {
                            res.data[0].info = {}
                            res.data[0].info.type = 'routes'
                            res.data[0].info.layout = 'normal'
                            //status = 1
                        }
                        else {
                            res.data[0].info.layout = '404'
                        }

                        set_content(content.current = res.data[0])
                        setLoading(false)
                    }
                    else {
                        if(article_id !== undefined && article_id !== 'undefined' && article_id !== '')
                            set_content(content.current = {id: id, info: {type: 'news', layout: '404'}, content: []})
                        else
                            set_content(content.current = {id: id, info: {type: 'content', layout: '404'}, content: []})

                        setLoading(false)
                    }
                })
                .catch(erro => console.log('ERROR', erro))
        }

        let getInfoRoutesAltId = async (id) => {
            await reqGET(`${Hosts.SIMCore_API}/platform/routes/${id}`)
                .then(res => { 
                    if(res.data.length > 0) {

                        //let status = 0
                        if(res.data[0].activo && res.data[0].visible !== '') {
                            res.data[0].info = {}
                            res.data[0].info.type = 'routesalt'
                            res.data[0].info.layout = 'normal'
                            //status = 1
                        }
                        else {
                            res.data[0].info.layout = '404'
                        }

                        set_content(content.current = res.data[0])
                        setLoading(false)
                    }
                    else {
                        if(article_id !== undefined && article_id !== 'undefined' && article_id !== '')
                            set_content(content.current = {id: id, info: {type: 'news', layout: '404'}, content: []})
                        else
                            set_content(content.current = {id: id, info: {type: 'content', layout: '404'}, content: []})

                        setLoading(false)
                    }
                })
                .catch(erro => console.log('ERROR', erro))
        }
    
        let getInfoSlug = async (slug) => {
            await reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/${slug}`)
                .then(res => { 
                    if(res.data.length > 0) {

                        var hoje = new Date();
                        let status = 0
                        if(res.data[0].info.date.published !== undefined && res.data[0].info.date.published !== '') {
                            var date_p = new Date(res.data[0].info.date.published);

                            status = 1
                            if(hoje >= date_p) 
                                status = 2
                        }

                        if(status !== 2) {
                            //res.data[0].content[0] = {text: 'rascunho ou agendado'}
                            res.data[0].info.layout = '404'
                        }
                        set_content(content.current = res.data[0])

                        setLoading(false)
                    }
                    else {
                        //console.log('slug: ', slug)
                        set_content(content.current = {id: '', info: {type: slug}})
  
                        setLoading(false)
                    }
                })
                .catch(erro => console.log('ERROR', erro))
        }

        if(preview_id !== undefined && preview_id !== 'undefined' && preview_id !== '') {
            getPreviewInfoId(preview_id)
               .then(() => {
               })
        }
        else if(pag_id !== undefined && pag_id !== 'undefined' && pag_id !== '') {
            getInfoId(pag_id)
        }
        else if(slug !== undefined && slug !== 'undefined' && slug !== '')  {
            getInfoSlug(slug)
        }
        else if(article_id !== undefined && article_id !== 'undefined' && article_id !== '')  {
            if(article_id === 'all') {
                // content.current.info['type'] = 'news'
                // content.current.info['layout'] = 'all'
                
                // set_content(content)
                setLoading(false)
            }
            else {
                getInfoId(article_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(press_id !== undefined && press_id !== 'undefined' && press_id !== '')  {
            //if(press_id === 'all') {
                // content.current.info['type'] = 'press'
                // content.current.info['layout'] = 'all'
                
                // set_content(content)
                set_content(content.current = {id: '', info: {type: 'press', layout: 'all'}, content: []})
                setLoading(false)
            //}
            /*else {
                getInfoId(press_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }*/
        }
        else if(gallery_id !== undefined && gallery_id !== 'undefined' && gallery_id !== '')  {
            if(gallery_id === 'all') {

                set_content(content.current = {id: '', info: {type: 'gallery', layout: 'all'}, content: []})
                setLoading(false)

            }
            else {
                getInfoId(gallery_id)
                    .then(() => {
                        setLoading(false)
                    })
            }
        }
        else if(event_id !== undefined && event_id !== 'undefined' && event_id !== '')  {
            if(event_id === 'all') {
                //content.current.info['type'] = 'event_id'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'event', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoId(event_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(animation_id !== undefined && animation_id !== 'undefined' && animation_id !== '')  {
            if(animation_id === 'all') {
                //content.current.info['type'] = 'animation'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'animation', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoId(animation_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(routes_id !== undefined && routes_id !== 'undefined' && routes_id !== '')  {
            if(routes_id === 'all') {
                //content.current.info['type'] = 'routes'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'routes', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoRoutesId(routes_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(routesalt_id !== undefined && routesalt_id !== 'undefined' && routesalt_id !== '')  {
            if(routesalt_id === 'all') {
                //content.current.info['type'] = 'routes'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'routesalt', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoRoutesAltId(routesalt_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(accommodation_id !== undefined && accommodation_id !== 'undefined' && accommodation_id !== '')  {
            if(accommodation_id === 'all') {
                //content.current.info['type'] = 'accommodation'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'accommodation', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoId(accommodation_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(restaurant_id !== undefined && restaurant_id !== 'undefined' && restaurant_id !== '')  {
            if(restaurant_id === 'all') {
                //content.current.info['type'] = 'restaurant'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'restaurant', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoId(restaurant_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else if(touristic_id !== undefined && touristic_id !== 'undefined' && touristic_id !== '')  {
            if(touristic_id === 'all') {
                //content.current.info['type'] = 'tourist_entertainment'
                // content.current.info['layout'] = 'all'

                set_content(content.current = {id: '', info: {type: 'tourist_entertainment', layout: 'all'}, content: []})
                setLoading(false)
            }
            else {
                getInfoId(touristic_id)
                    .then((res) => {
                        if(res === true){
                            setLoading(false)
                        }
                    })
            }
        }
        else {
            console.log('aaa')
        }
        
    }, [pag_id, slug, article_id, routes_id, routesalt_id, accommodation_id, restaurant_id, gallery_id, press_id, event_id, animation_id, preview_id]);

    return (isloading ?

		<Loader />
		
		:

        (() => {
            switch (content.current.info.type) {
                case 'content':
                    switch (content.current.info.layout) {

                        case 'card':
                            return (
                                <CardContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case 'accordion':
                            return (
                                <AccordionContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case 'tabs':
                            return (
                                <TabContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'contact':
                            return (
                                <ContactContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'list':
                            return (
                                <ListContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            ) 
                        
                        case 'list-alt':
                            return (
                                <ListAltContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            ) 
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: pag_id, preview: preview_id, slug: slug } }} />
                            )
                    }
                
                case 'news':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <NewsCardsContent info={{ state: { id: article_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <NewsContent info={{ state: { id: article_id, preview: preview_id, slug: slug } }} />
                            )
                        case '404':
                            return (
                                <NotFound info={{ state: { id: article_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: article_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'press':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <PressCardsContent info={{ state: { id: press_id, preview: preview_id, slug: slug } }} />
                            )
                        /*case 'normal':
                            return (
                                <PressContent info={{ state: { id: press_id, preview: preview_id, slug: slug } }} />
                            )*/
                        case '404':
                            return (
                                <NotFound info={{ state: { id: press_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            //console.log('aki aki');
                            return (
                                <PressCardsContent info={{ state: { id: press_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'gallery':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <GalleryCardsContent info={{ state: { id: gallery_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <GalleryContent info={{ state: { id: gallery_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: gallery_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: gallery_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'event':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <EventsCardsContent info={{ state: { id: event_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <EventsContent info={{ state: { id: event_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: event_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: event_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'animation':
                case 'activity':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <AnimationCardsContent info={{ state: { id: animation_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <AnimationContent info={{ state: { id: animation_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: animation_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: animation_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'routes':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <RoutesCardsContent info={{ state: { id: routes_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <RoutesContent info={{ state: { id: routes_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: routes_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: routes_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'routesalt':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <RoutesCardsContent info={{ state: { id: routesalt_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <RoutesContentAlt info={{ state: { id: routesalt_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: routesalt_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: routesalt_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'accommodation':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <AccommodationCardsContent info={{ state: { id: accommodation_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <AccommodationContent info={{ state: { id: accommodation_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: accommodation_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: accommodation_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'restaurant':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <RestaurantCardsContent info={{ state: { id: restaurant_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <RestaurantContent info={{ state: { id: restaurant_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: restaurant_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: restaurant_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                case 'tourist_entertainment':
                    switch (content.current.info.layout) {
                        case 'all':
                            return (
                                <TouristicOfferCardsContent info={{ state: { id: touristic_id, preview: preview_id, slug: slug } }} />
                            )

                        case 'normal':
                            return (
                                <TouristicOfferContent info={{ state: { id: touristic_id, preview: preview_id, slug: slug } }} />
                            )
                        
                        case '404':
                            return (
                                <NotFound info={{ state: { id: touristic_id, preview: preview_id, slug: slug } }} />
                            ) 

                        default:
                            return (
                                <NormalContent info={{ state: { id: touristic_id, preview: preview_id, slug: slug } }} />
                            )
                    }

                default:
                    return (
                        <Redirect to="/" />
                    )
            }
   
        })()
    
    )
}
